import React from 'react';
import { styled, ButtonChevron } from '@teko/ui';

const Wrapper = styled.div`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 0.8px solid #e0e0e0;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  margin-top: 0.3rem;
  float: right;
`;
const StyledButton = styled(ButtonChevron)`
  padding: 5px;
  margin: 0;
  position: relative;
  top: 2px;
`;
const ShowMoreBtn = ({
  setIsActive,
  isActive
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    onClick: () => setIsActive(!isActive)
  }, /* @__PURE__ */ React.createElement(StyledButton, {
    link: true,
    direction: isActive ? "up" : "down"
  }));
};

export { ShowMoreBtn };
